<template>
  <v-form ref="MANUAL_BILLING_DOCUMENT" @submit.prevent="sectionSave" lazy-validation class="section">
    <div>
      <section-header v-if="!hideTitle"
                      :ressource="ressource"
                      :isExtended="extended"
                      :dialog="dialog"
                      :picto="picto()"
                      :fiche=fiche
                      :isAbstract=isAbstract
                      @extended=setExtended
                      @closeDialog=closeDialog
                      ref="MANUAL_BILLING_DOCUMENT">
      </section-header>
      <div v-if="extended" id="field-container" :class="dialog ? 'p-0 p-md-3' : 'py-2'">
        <etablissement-select v-if="isDisplayed('ETABLISSEMENT_ID')"
                              ref="ETABLISSEMENT_ID"
                              :theme="theme"
                              :showMissing="showMissing"
                              v-model:value=etablissementId
                              :moduleId=moduleId
                              libelle="'Établissement'"
                              newLabel=''
                              selectText=""
                              @status=statusEtablissementId
                              :requiredAttributs="requiredAttributs"
                              :autoSelect=true
                              :ressource=ressourceEtablissementSelect
                              :filters=etablissementIdFilter
                              :toggleReset=resetEtablissementId
                              :required="isRequired('ETABLISSEMENT_ID')"
                              :contextId=manualBillingDocument.id
                              :readOnly="readOnly('ETABLISSEMENT_ID')"
                              :objType=objType
                              :fiche=fiche
                              :sectionName="sectionName">
        </etablissement-select>
        <manual-billing-document-kind v-if="isDisplayed('KIND')"
                                      ref="KIND"
                                      :theme="theme"
                                      :showMissing="showMissing"
                                      v-model:value=kind
                                      @status=statusKind
                                      :required="isRequired('KIND')"
                                      :contextId=manualBillingDocument.id
                                      :readOnly="readOnly('KIND')"
                                      :objType=objType
                                      :fiche=fiche
                                      :sectionName="sectionName">
        </manual-billing-document-kind>
        <manual-billing-document-in-cart v-if="isDisplayed('IN_CART')"
                                         ref="IN_CART"
                                         :theme="theme"
                                         :showMissing="showMissing"
                                         v-model:value=inCart
                                         @status=statusInCart
                                         :required="isRequired('IN_CART')"
                                         :contextId=manualBillingDocument.id
                                         :readOnly="readOnly('IN_CART')"
                                         :objType=objType
                                         :fiche=fiche
                                         :sectionName="sectionName">
        </manual-billing-document-in-cart>
        <manual-billing-document-ledger-code v-if="isDisplayed('LEDGER_CODE')"
                                             ref="LEDGER_CODE"
                                             :theme="theme"
                                             :showMissing="showMissing"
                                             v-model:value=ledgerCode
                                             @status=statusLedgerCode
                                             :required="isRequired('LEDGER_CODE')"
                                             :contextId=manualBillingDocument.id
                                             :readOnly="readOnly('LEDGER_CODE')"
                                             :objType=objType
                                             :fiche=fiche
                                             :sectionName="sectionName">
        </manual-billing-document-ledger-code>
        <manual-billing-document-effective-at v-if="isDisplayed('EFFECTIVE_AT')"
                                              ref="EFFECTIVE_AT"
                                              :theme="theme"
                                              :showMissing="showMissing"
                                              v-model:value=effectiveAt
                                              @status=statusEffectiveAt
                                              :periods='periodEffectiveAt'
                                              :required="isRequired('EFFECTIVE_AT')"
                                              :contextId=manualBillingDocument.id
                                              :readOnly="readOnly('EFFECTIVE_AT')"
                                              :objType=objType
                                              :fiche=fiche
                                              :sectionName="sectionName">
        </manual-billing-document-effective-at>
        <manual-billing-document-document-reference v-if="isDisplayed('DOCUMENT_REFERENCE')"
                                                    ref="DOCUMENT_REFERENCE"
                                                    :theme="theme"
                                                    :showMissing="showMissing"
                                                    v-model:value=documentReference
                                                    @status=statusDocumentReference
                                                    :over-ride-placeholder=placeholderDocumentReference
                                                    :required="isRequired('DOCUMENT_REFERENCE')"
                                                    :contextId=manualBillingDocument.id
                                                    :readOnly="readOnly('DOCUMENT_REFERENCE')"
                                                    :objType=objType
                                                    :fiche=fiche
                                                    :sectionName="sectionName">
        </manual-billing-document-document-reference>
        <manual-billing-document-reference v-if="isDisplayed('REFERENCE')"
                                           ref="REFERENCE"
                                           :theme="theme"
                                           :showMissing="showMissing"
                                           v-model:value=reference
                                           @status=statusReference
                                           :over-ride-placeholder=placeholderReference
                                           :required="isRequired('REFERENCE')"
                                           :contextId=manualBillingDocument.id
                                           :readOnly="readOnly('REFERENCE')"
                                           :objType=objType
                                           :fiche=fiche
                                           :sectionName="sectionName">
        </manual-billing-document-reference>
        <manual-billing-document-label v-if="isDisplayed('LABEL')"
                                       ref="LABEL"
                                       :theme="theme"
                                       :showMissing="showMissing"
                                       v-model:value=label
                                       @status=statusLabel
                                       :over-ride-placeholder=placeholderLabel
                                       :required="isRequired('LABEL')"
                                       :contextId=manualBillingDocument.id
                                       :readOnly="readOnly('LABEL')"
                                       :objType=objType
                                       :fiche=fiche
                                       :sectionName="sectionName">
        </manual-billing-document-label>
        <manual-billing-document-amount-ht v-if="isDisplayed('AMOUNT_HT')"
                                           ref="AMOUNT_HT"
                                           :theme="theme"
                                           :showMissing="showMissing"
                                           v-model:value=amountHt
                                           @status=statusAmountHt
                                           :required="isRequired('AMOUNT_HT')"
                                           :contextId=manualBillingDocument.id
                                           :readOnly="readOnly('AMOUNT_HT')"
                                           :objType=objType
                                           :fiche=fiche
                                           :sectionName="sectionName">
        </manual-billing-document-amount-ht>
        <manual-billing-document-vat-rate v-if="isDisplayed('VAT_RATE')"
                                          ref="VAT_RATE"
                                          :theme="theme"
                                          :showMissing="showMissing"
                                          v-model:value=vatRate
                                          @status=statusVatRate
                                          :required="isRequired('VAT_RATE')"
                                          :contextId=manualBillingDocument.id
                                          :readOnly="readOnly('VAT_RATE')"
                                          :objType=objType
                                          :fiche=fiche
                                          :sectionName="sectionName">
        </manual-billing-document-vat-rate>
        <manual-billing-document-amount-tva v-if="isDisplayed('AMOUNT_TVA')"
                                            ref="AMOUNT_TVA"
                                            :theme="theme"
                                            :showMissing="showMissing"
                                            v-model:value=amountTva
                                            @status=statusAmountTva
                                            :required="isRequired('AMOUNT_TVA')"
                                            :contextId=manualBillingDocument.id
                                            :readOnly="readOnly('AMOUNT_TVA')"
                                            :objType=objType
                                            :fiche=fiche
                                            :sectionName="sectionName">
        </manual-billing-document-amount-tva>
        <manual-billing-document-amount-ttc v-if="isDisplayed('AMOUNT_TTC')"
                                            ref="AMOUNT_TTC"
                                            :theme="theme"
                                            :showMissing="showMissing"
                                            v-model:value=amountTtc
                                            @status=statusAmountTtc
                                            :required="isRequired('AMOUNT_TTC')"
                                            :contextId=manualBillingDocument.id
                                            :readOnly="readOnly('AMOUNT_TTC')"
                                            :objType=objType
                                            :fiche=fiche
                                            :sectionName="sectionName">
        </manual-billing-document-amount-ttc>
        <manual-billing-document-payment-method v-if="isDisplayed('PAYMENT_METHOD')"
                                                ref="PAYMENT_METHOD"
                                                :theme="theme"
                                                :showMissing="showMissing"
                                                v-model:value=paymentMethod
                                                @status=statusPaymentMethod
                                                :over-ride-placeholder=placeholderPaymentMethod
                                                :required="isRequired('PAYMENT_METHOD')"
                                                :contextId=manualBillingDocument.id
                                                :readOnly="readOnly('PAYMENT_METHOD')"
                                                :objType=objType
                                                :fiche=fiche
                                                :sectionName="sectionName">
        </manual-billing-document-payment-method>
      </div>
    </div>
    <div v-if="extended" class="d-flex flex-row-reverse">
      <loader-button v-if="saveButton"
                     class="ms-2"
                     type="submit"
                     :loading="saveLoading"
                     :label="saveLabel"
                     :disabled="!updatedAndValid">
      </loader-button>
      <div v-for="(button, index) in extraButtons" :key="index">
        <loader-button class="ms-2"
                       :outlined="button.outlined"
                       @callback="button.callback()"
                       :type="button.type"
                       :label="button.label"
                       :loading="button.loading"
                       :disabled="button.disabled">
        </loader-button>
      </div>
    </div>
    <div class="d-flex flex-row-reverse" v-if="saveFailed && saveButton && extended">
      <p class="text-12 text-bold error-text">{{errorTxt}}</p>
    </div>
  </v-form>
</template>

<script lang="ts">
  import { defineComponent } from "vue";
  import CrudManualBillingDocument from '@/generated/cruds/CrudManualBillingDocument';
  // eslint-disable-next-line
  import { GenControl, GenSection, RessourceGenControl, RessourceGenSection } from '@/generated/ressources/generatedRessources';
  import { FwkButtons, RessourceFwkButton, RessourceFwkSection, FwkSections } from '@/ressources/globalRessources';
  import { Sections } from '@/generated/classes/AppSchema';
  import Button, { ButtonCallback } from '@/framework/base/classes/Button';
  import { ColumnFilter, ListChoix } from '@/extend/classes/ListData';
  import { ObjTypes } from '@/generated/classes/ObjTypes';

  export default defineComponent({
    extends:  CrudManualBillingDocument,
    components: {},
    props: {
      hideTitle: {
        type: Boolean,
      },
      isAbstract: {
        type: Boolean,
      },
    },

    data() {
      return {
        sectionName: Sections.MANUAL_BILLING_DOCUMENT,
        displayMap: new Map<string, Boolean>,
        readOnlyMap: new Map<string, Boolean>,
        requiredMap: new Map<string, Boolean>,
        placeholderDocumentReference: null,
        placeholderReference: null,
        placeholderLabel: null,
        placeholderPaymentMethod: null,
      }
    },

    computed: {
      saveLabel () { 
        return RessourceFwkButton(FwkButtons.ENREGISTRER).label;
      },

      errorTxt () { 
        return RessourceFwkSection(FwkSections.ERROR_TEXT).label;
      },

      ressourceEtablissementSelect () { return RessourceGenControl(GenControl.MANUAL_BILLING_DOCUMENT_ETABLISSEMENT_SELECT); },

      ressource () { return RessourceGenSection(GenSection.MANUAL_BILLING_DOCUMENT); },

      fields (): string[] {
        return ['ETABLISSEMENT_ID', 'KIND', 'IN_CART', 'LEDGER_CODE', 'EFFECTIVE_AT', 'DOCUMENT_REFERENCE', 'REFERENCE', 'LABEL', 'AMOUNT_HT', 'VAT_RATE', 'AMOUNT_TVA', 'AMOUNT_TTC', 'PAYMENT_METHOD'];
      },

      extraButtons (): Button[] {
        return [];
      },

      etablissementIdFilter (): ColumnFilter[] {
        const res: ColumnFilter[] = [];
        return res;
      },
    },
    methods: {
      getRequiredAttributs(): string[] {
        const res: string[] = [];
        if (this.requiredAttributs) {
          this.requiredAttributs.forEach((attrib) => {
            const value = attrib.split(".");
            if (value[0] == this.sectionName) {
              res.push(value[1])
            }
          })
        }
        return res;
      },

      requiredMissing(requiredAttributs: string[], value: string): boolean {
        return requiredAttributs.length > 0 && requiredAttributs.includes(value);;
      },

      readOnly (value: string): boolean {
        let res = false;
        if (!this.editManualBillingDocument.canUpdate) {
          return true;
        }
        if (this.readOnlyMap.size == 0) {
          this.readOnlyMap.set("ETABLISSEMENT_ID", false);
          this.readOnlyMap.set("KIND", false);
          this.readOnlyMap.set("IN_CART", false);
          this.readOnlyMap.set("LEDGER_CODE", false);
          this.readOnlyMap.set("EFFECTIVE_AT", false);
          this.readOnlyMap.set("DOCUMENT_REFERENCE", true);
          this.readOnlyMap.set("REFERENCE", false);
          this.readOnlyMap.set("LABEL", false);
          this.readOnlyMap.set("AMOUNT_HT", false);
          this.readOnlyMap.set("VAT_RATE", false);
          this.readOnlyMap.set("AMOUNT_TVA", false);
          this.readOnlyMap.set("AMOUNT_TTC", false);
          this.readOnlyMap.set("PAYMENT_METHOD", false);
        }
        const readOnly = this.readOnlyMap.get(value);
        if (readOnly != undefined) {
          res = readOnly;
        }
        return res;
      },

      isDisplayed (value: string): boolean {
        let res = true;
        if (this.displayMap.size == 0) {
        const requiredAttributs = this.getRequiredAttributs();
          this.displayMap.set("ETABLISSEMENT_ID", true);
          this.displayMap.set("KIND", true);
          this.displayMap.set("IN_CART", true);
          this.displayMap.set("LEDGER_CODE", true);
          this.displayMap.set("EFFECTIVE_AT", true);
          this.displayMap.set("DOCUMENT_REFERENCE", this.requiredMissing(requiredAttributs, "DOCUMENT_REFERENCE") || !!this.fiche);
          this.displayMap.set("REFERENCE", true);
          this.displayMap.set("LABEL", true);
          this.displayMap.set("AMOUNT_HT", true);
          this.displayMap.set("VAT_RATE", true);
          this.displayMap.set("AMOUNT_TVA", true);
          this.displayMap.set("AMOUNT_TTC", true);
          this.displayMap.set("PAYMENT_METHOD", this.requiredMissing(requiredAttributs, "PAYMENT_METHOD") || !!this.fiche);
        }
        const display = this.displayMap.get(value);
        if (display != undefined) {
          res = display;
        }
        return res;
      },

      isRequired (value: string): boolean {
        let res = true;
        const requiredAttributs = this.getRequiredAttributs();
        if (this.requiredMap.size == 0) {
          this.requiredMap.set("ETABLISSEMENT_ID", true);
          this.requiredMap.set("KIND", true);
          this.requiredMap.set("IN_CART", true);
          this.requiredMap.set("LEDGER_CODE", true);
          this.requiredMap.set("EFFECTIVE_AT", true);
          this.requiredMap.set("DOCUMENT_REFERENCE", this.requiredMissing(requiredAttributs, "DOCUMENT_REFERENCE") || !this.fiche);
          this.requiredMap.set("REFERENCE", true);
          this.requiredMap.set("LABEL", true);
          this.requiredMap.set("AMOUNT_HT", true);
          this.requiredMap.set("VAT_RATE", true);
          this.requiredMap.set("AMOUNT_TVA", true);
          this.requiredMap.set("AMOUNT_TTC", true);
          this.requiredMap.set("PAYMENT_METHOD", this.requiredMissing(requiredAttributs, "PAYMENT_METHOD") || !this.fiche);
        }
        const required = this.requiredMap.get(value);
        if (required != undefined) {
          res = required;
        }
        return res;
      },

      picto (): string {
        return 'SectionPictoDocument' 
      },

      sectionSave (): void {
        return this.save();
      }
    }
  })
</script>
